// @ts-nocheck
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import SlideoutLayout from '../../../layout/slideout/SlideoutLayout';
import FormCheckBoxList from '../../../common/FormCheckBoxList';
import { useTranslation } from 'react-i18next';
import Button from '../../../common/Button';
import { useAppDispatch, useAppSelector } from '../../../../hooks';
import { fetchCompanies } from '../../../../reducers/companyReducer';

function AddCompany({ done, cancel, assignedCompanies }) {

  const dispatch = useAppDispatch();
  const companies = useAppSelector((state) => state.companies);
  const { t } = useTranslation();
  const {
    formState: { errors },
    handleSubmit,
    control,
    setValue,
    getValues,
  } = useForm({
    defaultValues: {
      companies: assignedCompanies?.map((x) => x.id),
    },
  });

  // all companies
  useEffect(() => {
    if (!companies) {
      dispatch(fetchCompanies());
    }
  }, [companies, dispatch]);

  const onSubmit = (data) => {
    let selected = data.companies;
    let companyIds = assignedCompanies.map(x => x.id) ?? [];


    // added
    let added = selected.filter((item) => !companyIds.includes(item));

    // removed
    let removed = companyIds.filter((item) => !selected.includes(item));

    done({ added, removed });
  };

  return (
    <SlideoutLayout
      title={`Add company`}
      cancel={cancel}
      done={done}
      bar={
        <Button
          key="submit"
          text={t('Save')}
          className="btn btn-primary"
          onClick={handleSubmit(onSubmit)}
        />
      }
    >
      {companies && (
        <FormCheckBoxList
          label={t('Companies')}
          required
          name="companies"
          error={errors.keyProviders}
          getValues={getValues}
          setValue={setValue}
          control={control}
          items={
            companies
              ? [...companies]
                  ?.sort((a, b) => a.companyName.localeCompare(b.companyName))
                  .map((x) => ({
                    text: x.companyName,
                    value: x.id,
                  }))
              : null
          }
        />
      )}
    </SlideoutLayout>
  );
}



export default AddCompany;
